import React, { Component } from 'react';
import Cookies from 'universal-cookie';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';

class CookieAccept extends Component{

	constructor(props){
		super(props);
		this.cookies = new Cookies();
		this.state = {
			accept: false
		}
	}

	componentWillMount() {
		this.removeCookies();
	}

	removeCookies = () => {
		const cookieNames = ['_ga','_gat_gtag_UA_116808001_1','_gid'];
		cookieNames.forEach(name => {
			if(this.cookies.get(name)){
				this.cookies.remove(name, {
					path:'/',
					expires: '1970-01-01T00:00:01',
					domain: '.amikohome.com'
				});
			}
		});
	};

	activeGoogleAnalytics = () => {
		window.dataLayer = window.dataLayer || [];
		function gtag(){window.dataLayer.push(arguments);}
		gtag('js', new Date());
		gtag('config', 'UA-116808001-1', { 'anonymize_ip': true });
	};

	accept = (e) => {
		e.preventDefault();
		this.activeGoogleAnalytics();
		this.setState({accept:true});
	};

	decline = (e) => {
		e.preventDefault();
		this.removeCookies();
		this.setState({accept:true});
	};

	render(){
		const {accept} = this.state;

		if(accept){
			return null;
		}

		return (
			<div className="cookie-accept">
				<p>
					<FormattedHTMLMessage id="cookie-accept.question" />
				</p>
				<button className="btn btn-amiko" onClick={this.accept}>
					<FormattedMessage id="cookie-accept.button-accept" />
				</button>
				<button className="btn btn-default" onClick={this.decline}>
					<FormattedMessage id="cookie-accept.button-decline" />
				</button>
			</div>
		);
	}
}

export default CookieAccept;




// WEBPACK FOOTER //
// ./src/components/common/CookieAccept.js